import type { IUserInfo } from '@quick/go-api-types/src/users/me';

import { useFetch } from './useFetch';

export const useUserInfo = <TError,>(
  options?: Parameters<typeof useFetch<IUserInfo, TError>>[1]
) => {
  return useFetch<IUserInfo, TError>({ url: '/users/me', auth: true }, options);
};
